<div class="bg-night text-white p-6 rounded-xl overflow-x-hidden">
  <div class="mb-6">
    <h2 class="text-xl lg:text-2xl font-bold flex items-center gap-3 mb-2">
      <span class="material-symbols-outlined text-neon">close</span>
      {{ 'pos.session_info.close_confirm_title' | translate }}
    </h2>
    @if (sessionName()) {
      <p class="text-white/70 text-sm">
        {{ 'pos.session_info.close_confirm_message' | translate }}:
        <span class="font-medium">{{ sessionName() }}</span>
      </p>
    } @else {
      <p class="text-white/70 text-sm">{{ 'pos.session_info.close_confirm_message' | translate }}</p>
    }
  </div>

  <form
    [formGroup]="closeForm"
    class="space-y-4 mb-6">
    <div>
      <label class="block text-sm font-medium text-white/70 mb-2">
        {{ 'pos.session_info.close_closing_cash' | translate }}
        <span class="text-white/50 text-xs">({{ 'pos.session_info.close_closing_cash_optional' | translate }})</span>
      </label>
      <div class="relative">
        <span class="absolute left-4 top-1/2 -translate-y-1/2 material-symbols-outlined text-white/30">payments</span>
        <input
          type="number"
          formControlName="closingCashCents"
          data-testid="close-session-closing-cash"
          step="0.01"
          min="0"
          class="w-full bg-transparent border border-white rounded-full py-3 pl-12 pr-12 text-white placeholder-white/70 focus:outline-none focus:border-neon transition-all"
          placeholder="0.00" />
        <span class="absolute right-4 top-1/2 -translate-y-1/2 text-white/50 text-sm">€</span>
      </div>
      @if (closeForm.get('closingCashCents')?.hasError('min') && closeForm.get('closingCashCents')?.touched) {
        <p class="text-red-400 text-xs mt-1.5">{{ 'pos.session_info.close_closing_cash_min' | translate }}</p>
      }
    </div>
  </form>

  <div class="flex gap-3">
    <button
      type="button"
      (click)="close()"
      [disabled]="closing()"
      class="flex-1 border border-white/20 text-white hover:bg-white/10 font-medium py-3 px-6 rounded-full transition-all disabled:opacity-50 disabled:cursor-not-allowed">
      {{ 'admin.common.cancel' | translate }}
    </button>
    <button
      type="button"
      data-testid="close-session-confirm"
      (click)="confirm()"
      [disabled]="closing()"
      class="flex-1 bg-neon text-night font-bold py-3 px-6 rounded-full hover:bg-neon/80 transition-all uppercase disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
      @if (closing()) {
        <svg
          class="animate-spin h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24">
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span>{{ 'admin.common.loading' | translate }}</span>
      } @else {
        {{ 'pos.session_info.close_session' | translate }}
      }
    </button>
  </div>
</div>
